export const SET_SALES_OFFICE_ID = "SET_SALES_OFFICE_ID";
export const SET_CAMPAIGN_DATA = "SET_CAMPAIGN_DATA";
export const SET_MASTER_REP_DATA = "SET_MASTER_REP_DATA";
export const SET_PROFILE_ID = "SET_PROFILE_ID";
